import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14739b11&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeCarousel: require('/opt/buildhome/repo/components/Home/Carousel.vue').default,HomeCategorias: require('/opt/buildhome/repo/components/Home/Categorias.vue').default,CursosBannerCallToMeuPrimeiroEmprego: require('/opt/buildhome/repo/components/Cursos/BannerCallToMeuPrimeiroEmprego.vue').default})
